import axiosClient from './AxiosClient';
import {
  ReservationResponseDto,
  ReservationListResponseDto,
  ReservationControllerFindReservationRequest,
  ReservationControllerFindReservationListRequest,
  ReservationControllerCreateRequest,
  UpsertCustomerDto,
} from './generated/openapi';

const ReservationService = {
  getReservation(
    params: ReservationControllerFindReservationRequest,
  ): Promise<ReservationResponseDto> {
    return axiosClient
      .get<ReservationResponseDto>(`/reservation/reservation_get/${params.reservationId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to fetch data: ${error}`);
      });
  },

  getReservationList(
    params: ReservationControllerFindReservationListRequest,
  ): Promise<ReservationListResponseDto> {
    return axiosClient
      .get<ReservationListResponseDto>(`/reservation/reservation_slot_list`, {
        params: {
          tenpoCode: params.tenpoCode,
          reservationTypeMinutes: params.reservationTypeMinutes,
          week: params.week,
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to fetch data: ${error}`);
      });
  },

  createReservation(params: ReservationControllerCreateRequest) {
    return axiosClient
      .post('/reservation/create', { ...params.createReservationDto })
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to post data: ${error}`);
      });
  },

  confirmReservation(param: string) {
    return axiosClient
      .patch(`/reservation/confirm/${param}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to patch data: ${error}`);
      });
  },

  deleteReservation(param: string) {
    return axiosClient
      .delete(`/reservation/delete/${param}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to delete data: ${error}`);
      });
  },

  createCustomer(reservationId: string, params: UpsertCustomerDto) {
    return axiosClient
      .post(`/reservation/customer-create/${reservationId}`, params)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to create customer data: ${error}`);
      });
  },
};

export default ReservationService;
